import React, { useContext, useState } from 'react';
import * as S from './styled';
import { ValidityContext } from '../../../../../provider/ValidityProvider';
import Form from '../../..';
import { getFilterColumn, setFilterColumn } from '../../../../../store/utils';
import DateFilter from '../../../../DateFilter';

export default function FormStatusFilter() {
  const {
    autocompleteValidityStatus,
    getValidity,
    setValidity,
    searchFilter,
    setSearchFilter,
  } = useContext(ValidityContext)!.controllers.status;

  const autocompletes = getValidity('autocompletes.status');

  const [codeLoading, setCodeLoading] = useState(false);

  const autocompleteName = (e) => {
    setCodeLoading(true);
    autocompleteValidityStatus('name', e.target.value)
      .then((data) => {
        setValidity(`autocompletes.status.name.data`, data);
      })
      .finally(() => {
        setCodeLoading(false);
      });
  };

  const nameItems = autocompletes.name.data?.map((item) => ({
    id: item.id,
    name: `${item.value}`,
    data: item,
  }));

  const nameValue = getFilterColumn('name', searchFilter, 'LIKE');

  const getFilterField = (field: string, operator?: OPERATOR) =>
    getFilterColumn(field, searchFilter, operator);

  const setFilterField =
    (field: string, operator?: OPERATOR, format?: string) => (e) => {
      let filter = setFilterColumn(
        field,
        e.target.value,
        searchFilter,
        operator,
        'AND',
        format,
      );
      setSearchFilter({
        ...filter,
        page: 1,
      });
    };
  const setField =
    (field: any, operator?: OPERATOR, format?: string) => (e) => {
      setFilterField(field, operator, format)(e);
    };

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          <S.Field>
            <Form.Input.Dropdown
              label="Nome"
              items={nameItems}
              value={`${nameValue}`}
              onDebouncedChange={autocompleteName}
              errorMessage={false}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'name',
                  value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn('name', '', searchFilter, 'LIKE');
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'name',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              hasClearItem
              loading={codeLoading}
            />
          </S.Field>

          <S.DateContainer>
            <S.Label>Data de criação</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('createdAt', 'GTE') as string}
                onChange={setField('createdAt', 'GTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('createdAt', 'LTE') as string}
                onChange={setField('createdAt', 'LTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('createdAt', 'GTE') as string}
              finalDate={getFilterField('createdAt', 'LTE') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'createdAt',
                  initialDate,
                  searchFilter,
                  'GTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                filter = setFilterColumn(
                  'createdAt',
                  finalDate,
                  filter,
                  'LTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de atualização</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('updatedAt', 'GTE') as string}
                onChange={setField('updatedAt', 'GTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('updatedAt', 'LTE') as string}
                onChange={setField('updatedAt', 'LTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('updatedAt', 'GTE') as string}
              finalDate={getFilterField('updatedAt', 'LTE') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'updatedAt',
                  initialDate,
                  searchFilter,
                  'GTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                filter = setFilterColumn(
                  'updatedAt',
                  finalDate,
                  filter,
                  'LTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>
        </S.BodyContainer>
      </S.Body>
      <S.ClearButton
        onClick={(e) => {
          e.preventDefault();
          setValidity('filters.status.filter.filter', []);
        }}
      >
        Limpar
      </S.ClearButton>
    </S.Form>
  );
}
